import React from 'react';
import NavbarMulti from "../../../../../../components/Navbar/NavbarMulti";
import {ConfigApi, MultistoreLayoutType} from "../../../../../../services/Api/types";
import FetchPlaces from "../../../../../../components/Fetch/FetchPlaces";
import {usePlaceContext} from "../../../../../../services/Place/PlaceContext";
import MultistorePlaceCard from "../../../../components/PlaceCard/MultistorePlaceCard";
import Footer from "../../../../../../components/layout/Footer/Footer";
import {getLanguagesBasedOnStoreType} from "../../../../../../services/languageUtils";
import Hero from "../../../../../../components/Common/Hero";
import AppConfig from "../../../../../../services/AppConfig";
import IframeWidget from "../../../../../../utils/IframeWidget";
import {RootState} from "../../../../../../../reducers";
import {getSession} from "../../../../../../services/Session/reducer";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import MultistoreOrderingSteps from "./MultistoreOrderingSteps/MultistoreOrderingSteps";
import StoreUtils from "../../../../../../services/Store/StoreUtils";

interface OwnProps {
    config: ConfigApi;
}

type Props = ReturnType<typeof mapStateToProps> & OwnProps;

const MultistoreBrandListHomePage = ({config, session}: Props) => {
    const {places} = usePlaceContext();
    const availablePlaces = (places || []).filter(place => place.status === "ACTIVE" || place.status === "PAUSED");

    const scrollToPlacesSection = () => {
        const placesSection = document.getElementById("places");

        if (!placesSection) return;

        const navbarHeight = document.getElementById("main-navbar")?.clientHeight ?? 0;
        const scrollToOptions: ScrollToOptions = {
            top: placesSection.offsetTop - navbarHeight,
            behavior: "smooth"
        };

        if (AppConfig.isWidget()) {
            IframeWidget.scrollTo(scrollToOptions);
        } else {
            window.scrollTo(scrollToOptions);
        }
    };

    return (
        <div className="multistore-home-page multistore-page multistore-brand-list-home-page">
            <NavbarMulti config={config}/>
            <div className="inner-container">
                <Hero config={config} places={availablePlaces} onButtonClick={scrollToPlacesSection}/>
                {
                    StoreUtils.isQrcodeContext(session) && (
                        <MultistoreOrderingSteps places={availablePlaces} session={session} config={config}/>
                    )
                }
                <div className="sections">
                    <div className="places" id="places">
                        <FetchPlaces>
                            {(availablePlaces).map(place => (
                                <MultistorePlaceCard place={place} key={place.domain}
                                                     layout={MultistoreLayoutType.BRAND_LIST}/>
                            ))}
                        </FetchPlaces>
                    </div>
                    <Footer config={config} languages={getLanguagesBasedOnStoreType(config)}/>
                </div>
            </div>
        </div>
    )
}


const mapStateToProps = (state: RootState) => ({
    session: getSession(state.session)
});

const connector = connect(mapStateToProps);
export default withTranslation()(connector(MultistoreBrandListHomePage));